import React, { Component } from "react";
import {
  Typography,
  Grid,
  Hidden,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@material-ui/core";
import {
  RenderPageBanner,
  RenderSupportHeader,
  SupportQuickLinks,
} from "./CommonComponents";
import classnames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },

  bold: {
    fontWeight: "700",
  },
  subIndentation1: {
    marginLeft: "-20px",
  },
});

const REGULATORY_AGENCIES = [
  {
    ref: 1,
    name: "Anti-Money Laundering Council (AMLC)",
    purpose: "Regulatory Mandate",
    personal_information_shared:
      "Customer Informationm Card Transaction Information, Loan Details Information",
    intended_recipients: "AMLC",
  },
  {
    ref: 2,
    name: "Bangko Sentral ng Pilipinas (BSP)",
    purpose: "Regulatory Mandate, Audit Review",
    personal_information_shared:
      "Customer Information, Employment Information, Business Information, Card Transaction Information, Loan Details Information",
    intended_recipients: "BSP",
  },
  {
    ref: 3,
    name: "Bankers Association of the Philippines (BAP)",
    purpose: "Credit Underwriting Collections Organization's Mandate",
    personal_information_shared: "Customer Information ",
    intended_recipients: "BSP",
  },
  {
    ref: 4,
    name: "Credit Card Association of the Philippines (CCAP)",
    purpose: "Credit Underwriting Collections Organization's Mandate",
    personal_information_shared: "Customer Information ",
    intended_recipients: "Credit Underwriting & Collections Units",
  },
  {
    ref: 5,
    name: "Credit Information Corporation (CIC)",
    purpose: "Credit Underwriting Organization's Mandate",
    personal_information_shared:
      "Customer Information, Employment Information, Business Information, Card Transaction Information, Loan Details Information",
    intended_recipients:
      "Credit Underwriting Units CIC & Member Banks/Institutions",
  },
  {
    ref: 6,
    name: "TransUnion Philippines (TU)",
    purpose: "Credit Underwriting Organization's Mandate",
    personal_information_shared:
      "Customer Information, Employment Information, Business Information, Card Transaction Information, Loan Details Information",
    intended_recipients:
      "Credit Underwriting Units TU & Member Banks/Institution",
  },
];

const LIST_OF_FILINVEST_GROUPS = [
  "Filinvest Development Corporation",
  "East West Rural Bank Inc.",
  "East West Insurance Brokerage, Inc.",
  "East West Ageas Life Insurance Corporation",
  "East West Leasing and Finance Corporation",
  "Quest Marketing and Integrated Services, Inc.",
  "Assurance Solutions Insurance Agency",
  "Pacific Sugar Holdings Corporation (PSHC)",
  "FDC Forex Corporation (FFC)",
  "Filinvest Mimosa, Inc.",
  "Filinvest Land, Inc. (FLI)",
  "Filinvest Alabang, Inc. (FAI)",
  "Mactan Seascapes Services, Inc.",
  "FDC Utilities, Inc. (FDCUI)",
  "Filinvest Hospitality Corporation (FHC)",
  "Corporate Technologies Incorporated",
  "Chroma Hospitality, Inc.",
  "Filinvest Development Cayman Islands",
  "Countrywide Water Services, Inc.",
  "Luzon International Premiere Airport Development Corporation",
  "Professional Operations and Maintenance Experts Incorporated",
  "Filinvest-Hitachi Omni Waterworks, Inc.",
];
export const PrivacyStatementText = withStyles(styles)(function ({ classes }) {
  return (
    <>
      <div className={classnames(classes.spacer, classes.paperPadding)}>
        <Typography variant="body1" gutterBottom>
          <strong> East West Banking Corporation ("EWB" or "the Bank")</strong>{" "}
          values the confidentiality of your data and is committed to safeguard
          your privacy. This Data Privacy Statement (“Statement”) complies with
          the Philippine Republic Act No. 10173 known as the Data Privacy Act of
          2012 (DPA) and adheres to the privacy principles of transparency,
          legitimate purpose and proportionality.
          <br /> This Statement details how EWB collects, protects, uses,
          processes, stores, transmits, discloses, retains, disposes and
          destroys information when applying for, availing of or inquiring about
          our products and services, such as, but not limited to, deposits,
          cards, loans, investments, insurance, and such other products and
          services that the Bank offers or may offer from time to time.
          <br /> This Statement is primarily intended for EastWest Bank clients
          (natural, juridical persons and/or representatives thereof) in the
          Philippines. When accessing the Bank’s website, digital and electronic
          banking and communication channels, and/or social media pages from
          outside the Philippines, you acknowledge and agree that your
          information may be transferred to and processed in the Philippines
          following legal and regulatory standards for data protection that may
          differ from your current or home jurisdiction
        </Typography>
        <br />
        <div>
          {" "}
          <img
            alt="NPC Seal Of Registration"
            src="/images/logos/npc-seal-of-registration-large-2025.png"
            // className={classes.footerIcon}
            style={{ width: "60%" }}
          />
        </div>{" "}
        <br />
        <Typography variant="h6" color="primary" className={classes.bold}>
          How We Collect Information From You
        </Typography>
        <Typography variant="body1" gutterBottom>
          We collect your personal and business information through various
          interactions such as, but not limited to the following:
          <br />
          <ul>
            <li>When visiting and/or transacting at our stores/offices;</li>
            <li>
              When interacting with our employees, authorized representatives,
              agents and service providers;
            </li>
            <li>
              When inquiring about, applying for and availing of our products or
              services;
            </li>
            <li>
              When filling out the Bank’s application forms or other forms
              related to our products and services;
            </li>
            <li>
              When using the services of our digital and electronic banking and
              communication channels, such as, but not limited to, online and
              mobile banking, ATM banking, automated phone system, social media
              pages, messaging services among other technology platforms;
            </li>
            <li>
              When browsing or using our website for your inquiries and other
              concerns;
            </li>
            <li>
              When participating in any surveys, market research, studies and
              the like;
            </li>
            <li>When recording your voice and video conversations with us;</li>
            <li>
              When capturing your images via CCTV and other similar recording
              devices when visiting our stores or offices and/or when using our
              ATMs or other facilities;
            </li>
            <li>
              When interacting with our third-party service providers,
              accredited merchants and utility companies
            </li>
          </ul>
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          What Information We May Collect
        </Typography>
        <Typography variant="body1" gutterBottom>
          We may collect personal and business information and data, such as,
          but not limited to the following:
          <ul>
            <li>
              Your name and other particulars such as contact details,
              addresses, birthdate, business founding date, education
            </li>
            <li>Specimen signature</li>
            <li>
              Government-issued IDs and ID details (such as TIN, SSS, GSIS,
              Driver's license, Passport, etc.)
            </li>
            <li>
              Privately-issued IDs and ID details (such as company/employment
              ID, school ID, etc.)
            </li>
            <li>
              Business documents (such as certifications, license, registration
              documents etc.)
            </li>
            <li>
              Financial information (such as income, expenses, deposits,
              investments, credit cards, tax, insurance, financial and
              transaction history, relationships with other banks and/or
              financial institutions, business interests and assets, and the
              like)
            </li>
            <li>Employment details</li>
            <li>Voice and video recordings of our conversations with you</li>
            <li>
              Images captured via CCTV and other similar recording devices which
              may be observed when visiting our stores or offices and/or when
              using our ATMs or other facilities
            </li>
            <li>
              Information provided to our third-party service providers,
              accredited merchants and utility companies
            </li>
          </ul>
          <br />
          When necessary, we may ask our third-party service provider or the
          Bank, its subsidiaries or affiliates, to directly verify with you the
          supplied information or request you to provide additional information
          in order to comply with the requirements of regulators, supervisory or
          administrative bodies of the government, tax authorities, or to comply
          with the order of courts of competent jurisdiction.
          <br /> When you access our website or use any of our electronic
          banking and communication platforms, we collect non-personal
          information such as those provided by the device you are using (e.g.
          your phone) which may include the IP address, operating system, type
          and version of browser and other machine-related identifiers.
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          What We Do with The Information We Gather
        </Typography>
        <Typography variant="body1" gutterBottom>
          We use the information collected to:
          <ul>
            <li>
              Process, evaluate, facilitate and administer applications for our
              products and services, and transactions;
            </li>
            <li>
              Perform due diligence, including background investigation, credit
              investigation to verify your financial capacity, credit worthiness
              and the like;
            </li>
            <li>
              Provide you with information about our products or services;
            </li>
            <li>Manage your account and facilitate your transactions</li>
            <li>
              Respond to your inquiries, requests, feedback and other concerns,
              and use these information to further improve our products and
              services;
            </li>
            <li>
              Communicate with you, by sending out welcome letters, statements,
              notifications, advisories, alerts, and other forms of
              communication, whether written or using electronic or digital
              platform, necessary for continued use of our products and
              services;
            </li>
            <li>
              Provide you information on our products and services, marketing
              and sales offers, promotions, rewards, other features and
              benefits, and information about third parties which we think you
              may find interesting, through personalized customer touchpoints
              like our stores, call center, telemarketing, direct mail, e-mail,
              messaging, and other channels;
            </li>
            <li>
              Perform customer profiling, behavioral and transactional analyses,
              to understand customer needs, preferences and market trends,
              improve and offer suitable products and services, and enhance
              customer relationship;
            </li>
            <li>
              Conduct surveys, market research, studies and the like to review,
              evaluate, develop, and improve our products, services, policies
              and processes;
            </li>
            <li>
              Evaluate the effectiveness of marketing and sales programs and
              offers;
            </li>
            <li>
              Establish safeguards to identify, investigate and protect you from
              any unlawful activity, actual or suspected fraud or threats to our
              systems;
            </li>
            <li>
              Manage the Bank's operations, business continuity planning, and
              safety and security;
            </li>
            <li>
              Comply with the Bank’s obligations under the law and as required
              by government organizations such as, but not limited to, BSP and
              AMLC, SEC, NPC, BIR, DOLE, HDMF, PhilHealth, SSS, as well as those
              of other jurisdictions including the United States Foreign Account
              Tax Compliance Act (FATCA);
            </li>
            <li>Establish, exercise and defend the Bank's legal rights;</li>
            <li>
              Comply with legal and regulatory requirements, such as data
              submission to credit bureaus, credit information companies, the
              Credit Information Corporation (CIC), and responding to court
              orders and other instructions and requests from any local or
              foreign authorities including regulatory, governmental, tax and
              law enforcement authorities or other similar authorities;
            </li>
            <li>
              Comply with the requirements of audit and privacy
              assessments/reviews;
            </li>
            <li>
              Comply with the required reporting disclosures under applicable
              laws and regulations; and
            </li>
            <li>
              Perform such other activities allowed by law or with your consent.
            </li>
          </ul>
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          To Whom Do We Share Your Information With
        </Typography>
        <Typography variant="body1" gutterBottom>
          We take reasonable steps to enforce our privacy policy within the Bank
          and make sure that the personal and business information we collect
          shall be kept strictly confidential. However, in order to provide you
          with products and services suitable to your needs, with your prior
          consent, we may share your information with:
          <ul>
            <li>various units, offices and stores of the Bank</li>
            <li>
              subsidiaries, affiliates, and companies of the Filinvest Group
            </li>
            <li>
              authorized/accredited agents, representatives and third-party
              service providers
            </li>
            <li>banking associations, merchants, and partners</li>
            <li>banks and financial institutions, credit agencies</li>
            <li>
              regulatory and government agencies as required or authorized by
              law
            </li>
          </ul>
          Your personal and business data may be transferred, stored or
          processed outside the Philippines by any of the parties above. We
          ensure that the cross-border arrangement complies with the
          requirements of the Data Privacy Act and shall use means to provide a
          comparable level of protection while the information is being
          processed by above said parties.
          <br />
          We will not sell, distribute or lease your personal and business
          information to third-parties unless we have your permission or are
          required by law to do so. Please refer to Annex A for the list of
          regulatory agencies/credit agencies to which we share your personal
          information with.
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          How We Protect Your Personal Information
        </Typography>
        <Typography>
          We are committed to ensuring that your information is secure. In order
          to prevent unauthorized access or disclosure, we have put in place
          suitable physical, electronic and operational procedures to safeguard
          and secure the information we collect.
          <ul>
            <li>
              We keep and protect your personal and business data using a
              secured server behind a firewall, deploying encryption on
              computing devices and employing physical security controls.
            </li>
            <li>
              We restrict access to your personal and business data only to
              qualified and authorized personnel who hold your personal and
              business data with strict confidentiality.
            </li>
            <li>
              We are especially careful in our communications with minors and
              will not directly collect data from minors without the parents’ or
              guardian’s consent.
            </li>
          </ul>
          While the Bank is committed in protecting the security of your data,
          it is important for you to protect your account against unauthorized
          access by using a unique password and maintaining the security of your
          personal and business/corporate financial information by not sharing
          your password with anyone and by signing off when you have finished
          your digital and electronic banking transactions especially when using
          a shared computer.
          <br />
          Our website may contain links to other websites of interest or other
          websites operated by third parties. The Bank does not have control
          over these links and does not endorse or approve of the operators or
          the information, graphics and material on those websites. Therefore,
          we cannot be responsible for the protection and privacy of any
          information which you provide whilst visiting such sites. As such,
          sites are not governed by this Data Privacy Statement, it is important
          that you exercise caution and check into their own privacy statement.
          <br />A cookie is a small piece of information which a website stores
          on your web browser on your PC. A cookie is stored temporarily when
          you "Sign In" and is automatically destroyed when you close your
          browser.
          <br />
          We use traffic log cookies to identify which pages are being used and
          use this information for statistical analysis. This helps us analyze
          data about web page traffic and improve our website in order to tailor
          it to customer needs and thereafter the data is removed from the
          system.
          <br />
          Overall, cookies help us provide you with a better website by enabling
          us to monitor which pages you find useful and which you do not. A
          cookie does not give us access to your computer or any information
          about you other than the data you choose to share with us. You can
          choose to accept or decline cookies. If you choose to accept cookies,
          you will be able to take advantage of all the features of our website.
          <br />
          Non-identifiable web traffic data for the collection of technical
          information from devices that you use may include:
          <br />
          <ul>
            <li>Your internet protocol (IP) address</li>
            <li>The search terms you used</li>
            <li>The pages and internal links accessed on our sit</li>
            <li>Demographics</li>

            <li>
              The date and time you visited the site, including frequency of
              visits
            </li>
            <li>Geolocation</li>
            <li>Your operating system; and</li>
            <li>Web browser type</li>
          </ul>
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          How Long Do We Keep your Personal Information
        </Typography>
        <Typography variant="body1" gutterBottom>
          The Bank reserves the right to retain your personal and/or business
          information for as long as necessary for the fulfillment of the
          purposes for which the information was obtained or for the
          establishment, exercise or defense of legal claims or for legitimate
          purposes or as provided by law until such time that the information is
          no longer required nor necessary to keep to comply with legal,
          regulatory or internal requirements.
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          Your Rights
        </Typography>
        <Typography variant="body1" gutterBottom>
          The Bank respects your right to privacy under the Data Privacy Act as
          follows:
          <ol>
            <li>
              The right to be informed on the personal and/or business
              information that we collect and how it will be processed
            </li>
            <li>
              The right to object to the processing of your personal and/or
              business information including processing for direct marketing,
              automated processing or profiling and to withhold consent to the
              processing in case of changes or any amendment to the information
              supplied or declared
            </li>
            <li>
              The right to access or demand access to your personal and/or
              business information
            </li>
            <li>
              The right to rectification and to dispute any inaccuracy or error
              in your personal and/or business information
            </li>
            <li>
              The right to suspend, withdraw, order the blocking, removal or
              destruction of your information from the Bank’s system
            </li>
            <li>
              The right to damages and to be indemnified for any damages
              sustained due to inaccurate, incomplete, outdated, false,
              unlawfully obtained or unauthorized use of personal and/or
              business information, taking into account any violation of your
              rights and freedom
            </li>
            <li>
              The right to portability, to obtain a copy of such information in
              an electronic or structured format that is commonly used
            </li>
            <li>
              The right to lodge a complaint before the National Privacy
              Commission
            </li>
          </ol>
          <i>
            {" "}
            For further details, please refer to NPC's website:{" "}
            <a
              href="https://privacy.gov.ph/mechanics-for-complaints/."
              target="_blank"
            >
              https://privacy.gov.ph/mechanics-for-complaints/.
            </a>
          </i>
          <br />
          <br />
          We may charge a fee to cover administrative costs of verifying your
          request for information and for locating, retrieving, reviewing and
          copying any requested material or document.
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          Option to Opt-Out from Receiving Promotional Advertisements and Offers
        </Typography>
        <Typography variant="body1" gutterBottom>
          You may choose to opt-out from receiving promotional advertisements
          and offers by sending us an e-mail at{" "}
          <a href="mailto:service@eastwestbanker.com" target="_blank">
            service@eastwestbanker.com.
          </a>
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          Changes to our Data Privacy Statement
        </Typography>
        <Typography variant="body1" gutterBottom>
          It may be necessary for the Bank to change its Data Privacy Statement
          from time to time to align with recent laws, rules and regulations.
          The revised version will be posted in our website:
          <a href="www.eastwestbanker.com" target="_blank">
            www.eastwestbanker.com
          </a>{" "}
          and will take effect immediately.
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          Contact Us
        </Typography>
        <Typography variant="body1" gutterBottom>
          For any inquiry, request or concern on this Data Privacy Statement or
          your personal information, you may visit any of our stores or offices
          or you may choose to call our Customer Service Hotline at
          <a href="tel:(+632)88881700">(+632)88881700.</a>
          <br />
          <br />
          You may also contact our Data Protection Officer at:
          <br />
          <br />
          Data Protection Officer
          <br />
          East West Banking Corporation
          <br />
          Ground Floor EastWest Bank Building
          <br />
          2264 Pasong Tamo Extension, Makati City
          <br />
          E-mail Address:
          <a href="mailto:ewbdpo@eastwestbanker.com" target="_blank">
            ewbdpo@eastwestbanker.com
          </a>
        </Typography>
        <Typography variant="h6" color="primary" className={classes.bold}>
          Annex A: List of Regulatory Agencies/Credit Agencies to which we share
          your personal information
        </Typography>
        <Typography variant="body1" gutterBottom>
          <br />
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  className={classnames(
                    classes.paddingCell,
                    classes.centerAligned,
                    classes.bold
                  )}
                >
                  REF
                </TableCell>
                <TableCell
                  className={classnames(
                    classes.paddingCell,
                    classes.centerAligned,
                    classes.bold
                  )}
                >
                  NAME OF REGULATORY AGENCY/CREDIT AGENCY
                </TableCell>
                <TableCell
                  className={classnames(
                    classes.paddingCell,
                    classes.centerAligned,
                    classes.bold
                  )}
                >
                  PURPOSE(S) OF DATA SHARING
                </TableCell>
                <TableCell
                  className={classnames(
                    classes.paddingCell,
                    classes.centerAligned,
                    classes.bold
                  )}
                >
                  PERSONAL INFORMATION SHARED
                </TableCell>
                <TableCell
                  className={classnames(
                    classes.paddingCell,
                    classes.centerAligned,
                    classes.bold
                  )}
                >
                  INTENDED RECIPIENTS
                </TableCell>
              </TableRow>
            </TableHead>

            <tbody>
              {REGULATORY_AGENCIES.map(
                ({
                  ref,
                  name,
                  purpose,
                  personal_information_shared,
                  intended_recipients,
                }) => (
                  <TableRow>
                    <TableCell className={classnames(classes.paddingCell)}>
                      {ref}
                    </TableCell>
                    <TableCell
                      className={classnames(
                        classes.paddingCell,
                        classes.centerAligned
                      )}
                    >
                      {name}
                    </TableCell>
                    <TableCell
                      className={classnames(
                        classes.paddingCell,
                        classes.centerAligned
                      )}
                    >
                      {purpose}
                    </TableCell>
                    <TableCell
                      className={classnames(
                        classes.paddingCell,
                        classes.centerAligned
                      )}
                    >
                      {personal_information_shared}
                    </TableCell>
                    <TableCell
                      className={classnames(
                        classes.paddingCell,
                        classes.centerAligned
                      )}
                    >
                      {intended_recipients}
                    </TableCell>
                  </TableRow>
                )
              )}
            </tbody>
          </Table>
          <br />
          List of Filinvest Group of Companies:
          <br />
          <ol style={{ textAlign: "left" }}>
            {LIST_OF_FILINVEST_GROUPS.map((item) => (
              <li>{item}</li>
            ))}
          </ol>
        </Typography>
      </div>
    </>
  );
});

export default withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expanded: null,
      };
      this.handleChange = (panel) => (event, expanded) => {
        this.setState({
          expanded: expanded ? panel : false,
        });
      };
    }
    render() {
      return (
        <>
          <div id="pageBanner">
            <RenderPageBanner
              banner="/images/ewb-privacystatement-banner.jpg"
              bgColor="#fff"
            >
              <RenderSupportHeader
                color="primary"
                section="Privacy Statement"
                page=""
              />
            </RenderPageBanner>
          </div>
          <section className="greyBG">
            <Grid container className="gridContainer">
              <Grid item xs={12} md={8}>
                <PrivacyStatementText />
              </Grid>
              <Hidden smDown>
                <SupportQuickLinks
                  pagetitle="Back to Home"
                  link="/"
                  fontColor="primary"
                />
              </Hidden>
            </Grid>
          </section>
        </>
      );
    }
  }
);
